// Hook: call `handler` whenever the user presses Escape. Useful for closing
// modals. Pass an `enabled` flag (default true) so callers can disable while
// a nested modal is open or while editing.
import { useEffect } from "react";

export function useEscapeKey(handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    function onKey(e) {
      if (e.key === "Escape") {
        handler?.(e);
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handler, enabled]);
}
